import { NgModule } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { EditorModule } from '@tinymce/tinymce-angular';

import { SharedModule } from 'ish-shared/shared.module';

import { DotCmsDirectivesModule } from '../dot-cms-directives/dot-cms-directives.module';
import { DotCmsPipesModule } from '../pipes/dot-cms-pipes.module';

import { DotCmsBannerLinkComponent } from './content-types/dot-cms-banner/dot-cms-banner-link/dot-cms-banner-link.component';
import { DotCmsBannerComponent } from './content-types/dot-cms-banner/dot-cms-banner.component';
import { DotCmsBlockEditorBlockQuoteComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-block-quote/dot-cms-block-editor-block-quote.component';
import { DotCmsBlockEditorCodeBlockComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-code-block/dot-cms-block-editor-code-block.component';
import { DotCmsBlockEditorContentRenderComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-content-render/dot-cms-block-editor-content-render.component';
import { DotCmsBlockEditorHeadingComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-heading/dot-cms-block-editor-heading.component';
import { DotCmsBlockEditorHorizontalLineComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-horizontal-line/dot-cms-block-editor-horizontal-line.component';
import { DotCmsBlockEditorListOrderedComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-list-ordered/dot-cms-block-editor-list-ordered.component';
import { DotCmsBlockEditorListUnorderedComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-list-unordered/dot-cms-block-editor-list-unordered.component';
import { DotCmsBlockEditorParagraphComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-paragraph/dot-cms-block-editor-paragraph.component';
import { DotCmsBlockEditorTableComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-table/dot-cms-block-editor-table.component';
import { DotCmsBlockEditorVideoComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor-video/dot-cms-block-editor-video.component';
import { DotCmsBlockEditorComponent } from './content-types/dot-cms-block-editor/dot-cms-block-editor.component';
import { DotCmsBlogAuthorComponent } from './content-types/dot-cms-blog/dot-cms-blog-author/dot-cms-blog-author.component';
import { DotCmsBlogCommentsComponent } from './content-types/dot-cms-blog/dot-cms-blog-comments/dot-cms-blog-comments.component';
import { DotCmsBlogDetailComponent } from './content-types/dot-cms-blog/dot-cms-blog-detail/dot-cms-blog-detail.component';
import { DotCmsBlogPostComponent } from './content-types/dot-cms-blog/dot-cms-blog-post/dot-cms-blog-post.component';
import { DotCmsBlogComponent } from './content-types/dot-cms-blog/dot-cms-blog.component';
import { DotCmsCarouselComponent } from './content-types/dot-cms-carousel/dot-cms-carousel.component';
import { DotCmsCategoryCardComponent } from './content-types/dot-cms-category-list-manual/dot-cms-category-card/dot-cms-category-card.component';
import { DotCmsCategoryListManualComponent } from './content-types/dot-cms-category-list-manual/dot-cms-category-list-manual.component';
import { DotCmsCategorySwiperComponent } from './content-types/dot-cms-category-list-manual/dot-cms-category-swiper/dot-cms-category-swiper.component';
import { DotCmsCategoryTileComponent } from './content-types/dot-cms-category-list-manual/dot-cms-category-tile/dot-cms-category-tile.component';
import { DotCmsContentRenderComponent } from './content-types/dot-cms-content-render/dot-cms-content-render.component';
import { DotCmsFallbackComponent } from './content-types/dot-cms-fallback/dot-cms-fallback.component';
import { DotCmsFaqComponent } from './content-types/dot-cms-faq/dot-cms-faq.component';
import { DotCmsGlobalCarouselComponent } from './content-types/dot-cms-global-carousel/dot-cms-global-carousel.component';
import { DotCmsImageComponent } from './content-types/dot-cms-image/dot-cms-image.component';
import { DotCmsMasterCategoryCardComponent } from './content-types/dot-cms-master-category-card/dot-cms-master-category-card.component';
import { DotCmsProductCarouselListComponent } from './content-types/dot-cms-product-carousel/dot-cms-product-carousel-list/dot-cms-product-carousel-list.component';
import { DotCmsProductItemComponent } from './content-types/dot-cms-product-carousel/dot-cms-product-carousel-list/dot-cms-product-item/dot-cms-product-item.component';
import { DotCmsProductTileComponent } from './content-types/dot-cms-product-carousel/dot-cms-product-carousel-list/dot-cms-product-item/dot-cms-product-tile/dot-cms-product-tile.component';
import { DotCmsProductSwiperComponent } from './content-types/dot-cms-product-carousel/dot-cms-product-carousel-list/dot-cms-product-swiper/dot-cms-product-swiper.component';
import { DotCmsProductCarouselComponent } from './content-types/dot-cms-product-carousel/dot-cms-product-carousel.component';
import { DotCmsProductsTooltipComponent } from './content-types/dot-cms-products-tooltip/dot-cms-products-tooltip.component';
import { DotCmsBannerVideoComponent } from './content-types/dot-cms-video/dot-cms-banner-video/dot-cms-banner-video.component';
import { DotCmsVideoComponent } from './content-types/dot-cms-video/dot-cms-video.component';
import { DotCmsVimeoVideoComponent } from './content-types/dot-cms-video/dot-cms-vimeo-video/dot-cms-vimeo-video.component';
import { DotCmsYoutubeVideoComponent } from './content-types/dot-cms-video/dot-cms-youtube-video/dot-cms-youtube-video.component';
import { DotCmsWebPageContentComponent } from './content-types/dot-cms-web-page-content/dot-cms-web-page-content.component';
import { DotcmsFaqWidgetComponent } from './content-types/dotcms-faq-widget/dotcms-faq-widget.component';
import { DotCmsContainerComponent } from './layout/dot-cms-container/dot-cms-container.component';
import { DotCmsContentletComponent } from './layout/dot-cms-contentlet/dot-cms-contentlet.component';
import { DotCmsEditContainerWrapperComponent } from './layout/dot-cms-edit-container-wrapper/dot-cms-edit-container-wrapper.component';
import { DotCmsEditContentletWrapperComponent } from './layout/dot-cms-edit-contentlet-wrapper/dot-cms-edit-contentlet-wrapper.component';
import { DotCmsLayoutGridComponent } from './layout/dot-cms-layout-grid/dot-cms-layout-grid.component';
import { DotCmsLayoutComponent } from './layout/dot-cms-layout/dot-cms-layout.component';
import { DotCmsPageComponent } from './layout/dot-cms-page/dot-cms-page.component';
import { DotCmsRowComponent } from './layout/dot-cms-row/dot-cms-row.component';
import { DotEditableTextComponent } from './layout/dot-editable-text/dot-editable-text.component';

const declaredComponents = [
  DotCmsLayoutComponent,
  DotCmsLayoutGridComponent,
  DotCmsRowComponent,
  DotCmsContainerComponent,
  DotCmsContentletComponent,
  DotCmsWebPageContentComponent,
  DotCmsContentRenderComponent,
  DotCmsImageComponent,
  DotCmsBannerComponent,
  DotCmsCategoryListManualComponent,
  DotCmsCategoryTileComponent,
  DotCmsEditContainerWrapperComponent,
  DotCmsEditContentletWrapperComponent,
  DotCmsFallbackComponent,
  DotCmsCarouselComponent,
  DotCmsGlobalCarouselComponent,
  DotCmsVideoComponent,
  DotCmsVimeoVideoComponent,
  DotCmsYoutubeVideoComponent,
  DotCmsFaqComponent,
  DotCmsBlogComponent,
  DotcmsFaqWidgetComponent,
  DotCmsBlogCommentsComponent,
  DotCmsCategorySwiperComponent,
  DotCmsProductCarouselComponent,
  DotCmsProductCarouselListComponent,
  DotCmsBlogAuthorComponent,
  DotCmsBlogDetailComponent,
  DotCmsBlogPostComponent,
  DotCmsProductItemComponent,
  DotCmsProductSwiperComponent,
  DotCmsProductTileComponent,
  DotCmsCategoryCardComponent,
  DotCmsBannerVideoComponent,
  DotCmsProductsTooltipComponent,
  DotCmsBlockEditorComponent,
  DotCmsBlockEditorParagraphComponent,
  DotCmsMasterCategoryCardComponent,
  DotCmsBlockEditorBlockQuoteComponent,
  DotCmsBlockEditorCodeBlockComponent,
  DotCmsBlockEditorHeadingComponent,
  DotCmsBlockEditorHorizontalLineComponent,
  DotCmsBlockEditorListOrderedComponent,
  DotCmsBlockEditorListUnorderedComponent,
  DotCmsBlockEditorTableComponent,
  DotCmsBlockEditorContentRenderComponent,
];

const exportedComponents = [
  DotCmsCategorySwiperComponent,
  DotCmsMasterCategoryCardComponent,
  DotCmsPageComponent,
  DotCmsEditContentletWrapperComponent,
  DotCmsContentRenderComponent,
  DotcmsFaqWidgetComponent,
  DotCmsBannerLinkComponent,
  DotCmsWebPageContentComponent,
  DotCmsProductItemComponent,
  DotCmsProductsTooltipComponent,
  DotCmsBlockEditorVideoComponent,
  DotCmsBlockEditorContentRenderComponent,
];

@NgModule({
  declarations: [...declaredComponents, ...exportedComponents, DotEditableTextComponent],
  exports: [...exportedComponents, SharedModule],
  imports: [DotCmsDirectivesModule, DotCmsPipesModule, EditorModule, NgbAccordionModule, SharedModule],
})
export class DotCmsComponentsModule {}
